import axios from 'axios';
import { handleAxiosError } from 'core/notifications';
import map from 'lodash/map';

import getSelectOptions from './getSelectOptions';

const filterParams = (values) =>
  Object.fromEntries(Object.entries(values).filter(([, value]) => value !== undefined));

export default async ({ searchValue, organizationId, membershipType, reject = null, role }) => {
  const values = {
    organization_id: organizationId,
    search_query: searchValue,
    membership_type: membershipType,
    limit: !searchValue ? 5 : undefined,
    reject,
    role,
  };
  const searchParams = new URLSearchParams(filterParams(values));
  const url = `/api/admin/permissions/groups_and_admins?${searchParams.toString()}`;

  try {
    const { data } = await axios.get(url);
    const transformedData = map(data.data, (user) => ({
      name: user.name,
      avatar: user.avatar_path,
      code: user.code,
      id: user.id,
      membersCount: user.metadata.number_of_members || null,
      eligibleMembers: user.metadata.number_of_eligible_members || null,
      jobTitle: user.metadata.job_title,
      type: user.type,
    }));
    return getSelectOptions(transformedData);
  } catch (error) {
    handleAxiosError(error);
  }
};
